import type { WorkbookDefinition, WorkbookSource } from '@erp/shared-types';

/** The longest Workbook name `workbooks.create` accepts. */
export const WORKBOOK_NAME_MAX_LENGTH = 200;

/** Why the name step cannot be left yet, or null when it can. */
export function workbookNameProblem(
  name: string,
): 'missing' | 'too-long' | null {
  const trimmed = name.trim();
  if (!trimmed) return 'missing';
  if (trimmed.length > WORKBOOK_NAME_MAX_LENGTH) return 'too-long';
  return null;
}

/**
 * The Definition the wizard's Add data reads before the Workbook exists: only
 * its chosen Sources matter (they are not offered again, and a pasted table's
 * name must not repeat one).
 */
export function wizardDraftDefinition(
  name: string,
  sources: readonly WorkbookSource[],
): WorkbookDefinition {
  return {
    formatVersion: 1,
    name: name.trim() || 'Workbook',
    instructions: '',
    processSteps: [],
    files: [],
    sources: [...sources],
    sheets: [],
    outputs: [],
    taskRules: [],
  };
}

/** The new Workbook's Definition with the wizard's data and instructions in it. */
export function wizardWorkbookDefinition(
  created: WorkbookDefinition,
  sources: readonly WorkbookSource[],
  instructions: string,
): WorkbookDefinition {
  return {
    ...created,
    sources: [...created.sources, ...sources],
    instructions: instructions.trim(),
  };
}

/** Whether the wizard has anything to save past the empty Workbook `create` makes. */
export function wizardHasContent(
  sources: readonly WorkbookSource[],
  instructions: string,
): boolean {
  return sources.length > 0 || instructions.trim() !== '';
}
